import BatteryAlerts from './attributes/BatteryAlerts';
import BatteryAlertsDetailRenderer from './detail/BatteryAlertsDetailRenderer';
import BatteryAlertsEqualsComparator from './filters/BatteryAlertsEqualsComparator';
import BatteryAlertsEqualsComparatorEditor from './filters/BatteryAlertsEqualsComparatorEditor';
import BatteryAlertsEqualsComparatorFilterConverter from './filters/BatteryAlertsEqualsComparatorFilterConverter';
import BatteryAlertsCellRenderer from './table/BatteryAlertsCellRenderer';
export default {
  install(molten) {
    molten.addPlugin('Attribute', BatteryAlerts);
    molten.addPlugin('AttributeCellRenderer', BatteryAlertsCellRenderer);
    molten.addPlugin('AttributeValueRenderer', BatteryAlertsDetailRenderer);
    molten.addPlugin('AttributeConditionComparator', BatteryAlertsEqualsComparator);
    molten.addPlugin('AttributeConditionComparatorEditor', {
      type: BatteryAlertsEqualsComparator.TYPE,
      editor: BatteryAlertsEqualsComparatorEditor
    });
    molten.addPlugin('ImagineComparatorFilterConverter', BatteryAlertsEqualsComparatorFilterConverter);
  }
};